import { ClosablePopoverUniDriver } from './ClosablePopover/ClosablePopover.uni.driver';
import { FloatingHelperContentUniDriver } from './FloatingHelperContent/FloatingHelperContent.uni.driver';

export interface FloatingHelperUniDriver extends ClosablePopoverUniDriver {
  hasCloseButton(): Promise<boolean>;
  clickCloseButton(): Promise<void>;
  /**
   * Gets the driver for the helper's content
   * @return {FloatingHelperContentUniDriver}
   */
  helperContent: FloatingHelperContentUniDriver;
  /** @deprecated use helperContent */
  getHelperContentDriver(): Promise<FloatingHelperContentUniDriver>;
  getWidth(): Promise<string>;
}
